// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"33c1dee8","688":"2b97ed83","751":"610d63db","936":"fe0271b3"}[chunkId] + ".chunk.js";
};